import { Link } from 'react-router-dom';
import { Calculator } from 'lucide-react';

export default function EstimateFab({ to = '/estimasi-biaya' }) {
  return (
    <Link
      to={to}
      data-testid="estimate-fab"
      aria-label="Cek Estimasi Biaya"
      className="relative inline-flex group"
    >
      <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-40" />
      <span className="relative flex items-center gap-2 bg-px-red group-hover:bg-red-700 text-white text-sm font-semibold rounded-full pl-4 pr-5 py-3 shadow-xl shadow-red-600/40 transition-transform group-hover:scale-105 animate-pulse">
        <Calculator className="w-4 h-4" />
        Cek Estimasi Biaya
      </span>
    </Link>
  );
}
